/**
 * AUDIOSPRITE DEFINITIONS
 */
export const GAME_SFX_BASE = 'games_sfx_base';

export const BACKGROUND_MUSIC = 'title_music';
export const GAME_MUSIC = 'bg_music';

/**
 * UI SFX
 */
export const UI_SFX_BUTTON = 'click_mouse_over';

export const GAME_SFX_APPLE_SELECT = 'apple_chosen';
export const GAME_SFX_ONION_SELECT = 'onion_chosen';

export const GAME_SFX_APPLE_LOSE = 'apple_lose';
export const GAME_SFX_ONION_LOSE = 'onion_lose';

export const GAME_SFX_FOOTSTEPS = 'footsteps';
export const GAME_SFX_COLLISION = 'collision_trolley';
export const GAME_SFX_APPLE_WIN = 'apple_yeah';
export const GAME_SFX_ONION_WIN = 'onion_chaching';
export const GAME_SFX_PATTY = 'patty_soproud';

export const GAME_SFX_MUSICAL_MOMENT = 'musical_moment';
export const GAME_SFX_GAME_COMPLETE = 'game_complete';

export const GAME_SFX_CLICK_SELECT = 'click_mouse_over';

export const GAME_SFX_INSTRUCTION_WOOSH = 'INSTRUCTION_WOOSH';
